import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { ProgressBar } from 'components/progress-bar';
import { Box, BoxProps, withTypography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

import theme from './theme';
import { IFreeDeliveryProgressProps } from './types';

const Container = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.container, style]} />
);

const Title = withTypography({
  variant: 'headerThree',
  color: primitive.$crunchyGreen,
  style: {
    marginBottom: spacing.$0,
  },
});

const SubText = withTypography({ color: theme.subTextColor });

const FreeDeliveryProgress: React.FC<React.PropsWithChildren<IFreeDeliveryProgressProps>> = ({
  isLoading,
  isFreeDelivery,
  freeDeliveryPercentageComplete,
  titleLabel,
  freeDeliveryInProgressLabel,
}) => (
  <Container testID="free-delivery-progress">
    {isLoading ? (
      <>
        <Skeleton height="20px" width="80%" color={primitive.$greyFour} />
        <Skeleton height="25px" width="full" color={primitive.$greyFour} />
        <Skeleton height="20px" width="80%" color={primitive.$greyFour} />
      </>
    ) : (
      <>
        <Title>{titleLabel}</Title>
        {!isFreeDelivery && (
          <>
            <ProgressBar
              percentage={freeDeliveryPercentageComplete}
              fillColor={primitive.$crunchyGreen}
            />
            <SubText>{freeDeliveryInProgressLabel}</SubText>
          </>
        )}
      </>
    )}
  </Container>
);

export default FreeDeliveryProgress;

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    borderTopColor: '#aaaaaa',
    borderTopWidth: 1,
    gap: spacing.$1,
    marginTop: spacing.$2_5,
    paddingTop: spacing.$4,
  },
});
